import { render } from "./PopupsConfig.vue?vue&type=template&id=fd27a3e6&scoped=true"
import script from "./PopupsConfig.vue?vue&type=script&lang=js"
export * from "./PopupsConfig.vue?vue&type=script&lang=js"

import "./PopupsConfig.vue?vue&type=style&index=0&id=fd27a3e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd27a3e6"]])

export default __exports__